import React, { useEffect, useState } from "react";
import { InputGroup, FormControl, Alert } from "react-bootstrap";

import leftIcon from "../../assets/Icons/leftArrow.svg";
import Logo from "../../assets/Icons/Frame 476.png";
import { Link, useNavigate } from "react-router-dom";
import "../../styles/Login.scss";
import OTPInput from "react-otp-input";
import { useDispatch, useSelector } from "react-redux";
import { isError } from "../../redux/selectors/authSelector";


const EmailVerification = ({ loader, onVerifyAction, sentOTP }) => {
  const navigate = useNavigate();
  const [mobile_otp, setOtp] = useState("");
  const [remainingTime, setRemainingTime] = useState(59);
  const [isResendEnabled, setIsResendEnabled] = useState(false);
  const errorMsg = useSelector(isError);

  useEffect(() => {
    let timerInterval;
    if (remainingTime > 0) {
      timerInterval = setInterval(() => {
        setRemainingTime((prevTime) => prevTime - 1);
      }, 1000);
    } else if (remainingTime === 0) {
      setIsResendEnabled(true);
    }

    return () => {
      clearInterval(timerInterval);
    };
  }, [remainingTime]);

  const handleResend = () => {
    setRemainingTime(59); // Reset timer
    setIsResendEnabled(false); // Hide resend text
    if (sentOTP) sentOTP(); // Call the resend OTP function if provided
  };

  useEffect(() => {
    setOtp(""); // Reset the OTP input field
    setRemainingTime(59); // Restart the timer
    setIsResendEnabled(false); // Disable resend button
  }, []);
  return (
    <>
      <div className="card-body pt-0">
        <h3 className="text-center mt-4">
          <a href="/" className="logo logo-admin">
            <img src={Logo} height="100" alt="logo" className=" mb-4" style={{ width: "220px" }}/>
          </a>
          <div className="d-flex align-items-center justify-content-start">
            <img src={leftIcon} alt="logo" onClick={() => navigate(-1)} />{" "}
            <h3 className="ps-5 ms-5 mb-0">Email Verification</h3>
          </div>
          <p className="sub-title">
            Please enter the verification code sent to your registered email id.
          </p>
        </h3>
        <div className="login-container">
              <label className="flex justify-center">Enter Verification Code <span className="text-danger">*</span></label>
          <div className="otp-wrap">
            <div className="otp-fields d-flex justify-content-between ">
              <OTPInput
                value={mobile_otp}
                onChange={setOtp}
                numInputs={6}
                inputType="tel"
                isInputNum={true}
                placeholder="000000"
                shouldAutoFocus={true}
                inputStyle="otp-field form-control input-group"
                containerStyle={{
                  display: "flex",
                  gap: "10px", // modern and cleaner spacing
                  justifyContent: "center",
                }}
                renderInput={(props) => <input {...props} />}
              />
            </div>

            <div className="otp-resend d-flex justify-content-center">
              {isResendEnabled ? <div>00:00</div> : <span>00:{remainingTime}s</span>}
              {/* {isResendEnabled && (
                // <Link onClick={handleResend}>Resend Code</Link>
                <p className="text-center pt-3 font-sm">
                  Didn’t receive the code?{" "}
                  <span className="resend-otp primary" onClick={handleResend}>Resend</span>{" "}
                </p>
              )} */}
            </div>
          </div>
            {
              !remainingTime && (<p className="text-center pt-3 font-sm">
                Didn’t receive the code?{" "}
                <span className="resend-otp primary" onClick={handleResend}>Resend</span>{" "}
              </p>)
            }
          {/* <p className="text-center pt-3 font-sm">
            Didn’t receive the code?{" "}
            <span className="resend-otp primary" onClick={handleResend}>Resend</span>{" "}
          </p> */}
          <button
            type="submit"
            className="sign-in-button mb-3 w-100"
            onClick={() => onVerifyAction(mobile_otp)}
            disabled={loader}
          >
            {loader ? "Please wait..." : "Verify"}
          </button>
        </div>
      </div>
    </>
  );
};

export default EmailVerification;
